module.exports = __webpack_public_path__ + "img/personal-center.df47a9d7.svg";